module.exports = __webpack_public_path__ + "img/outlook.307d13ed.png";